import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { fetchPhpEigth } from 'api';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import DynamicForm from 'components/DynamicForm';
import { BaseButton } from 'components/InputsMex/inputs';
import ModalContratante from 'components/ModalMex/ModalContratante';
import Page from 'components/Page';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import COLORS from 'utils/constants/COLORS';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { guardarTracking } from 'utils/tracking';
import Loading from 'wrappers/Loading';
import { CASUALITY_GENERAL } from '../constantes';

export const ContratanteCasualityGenerales = () => {
  const history = useHistory();
  const { id = '' } = useQueryParams();
  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const [validaciones, setValidaciones] = useState(null);
  useNavbarContext(PRODUCTOS.CASUALITY_GENERAL);
  const methods = useForm({ mode: 'onChange' });
  const { reset } = methods;
  const { addSuccessToast } = useCustomToast();
  //const [pasosRedireccion, setPasosRedireccion] = useState([]);

  const guardarInformacion = async (data, guardarDatos = true) => {
    guardarTracking(
      CASUALITY_GENERAL.endpoints.guardarTracking,
      id || '',
      'Guardar información contratante',
      'Guardar catalogo',
      window.location.href
    );
    setLoading(true);
    const Data = {
      id,
      save: guardarDatos,
      data,
    };

    const res = await fetchPhpEigth(CASUALITY_GENERAL.endpoints.guardarContratante, Data);
    console.log(res, 'respuesta');
    // reset(data);
    setLoading(false);
    if (guardarDatos && res.transaccion) {
      await getData(true);
    }
    return res;
  };

  const onSubmit = async (data) => {
    const res = await guardarInformacion(data, false);
    if (res?.transaccion === true) {
      guardarTracking(
        CASUALITY_GENERAL.endpoints.guardarTracking,
        id || '',
        'Click continuar en pantalla contratante',
        'Guardar contratante',
        window.location.href
      );
      history.push(`${CASUALITY_GENERAL.urls.vigencia}?id=${id || ''}`);
    }
  };

  const getData = useCallback(
    async (guardado = false) => {
      guardarTracking(
        CASUALITY_GENERAL.endpoints.guardarTracking,
        id || '',
        'Carga catalogo contratante',
        'Cargar catalogo',
        window.location.href
      );

      setLoading(true);
      try {
        const body = {
          polCodigo: id,
          prodCodigo: CASUALITY_GENERAL.codProducto,
          pasoRevContratante: 'obtenerContratante',
          pasoCatContratante: 'catalogoContratante',
          formulario: 'contratante',
          formCodigo: 'formCASUALTYGENERALES',
          datosCotizador: {
            formCodigo: 'formCASUALTYGENERALES',
          },
        };
        const res = await fetchPhpEigth(CASUALITY_GENERAL.endpoints.catalogoContratante, body);

        setCatalogo(res.data.catalogo);
        setValidaciones(res?.data?.catalogo?.validaciones || null);

        if (res?.data?.catalogo?.DatosContratanteAsegurado) {
          reset(res?.data?.catalogo?.DatosContratanteAsegurado);
        }
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
      if (guardado) {
        await addSuccessToast(`¡Contratante guardado con éxito!`, { autoDismiss: false });
      }
    },
    [id, reset]
  );

  const regresar = () => {
    guardarTracking(
      CASUALITY_GENERAL.endpoints.guardarTracking,
      id || '',
      'Click atrás pantalla 4 Casuality',
      'Regresar pantalla 4',
      window.location.href
    );
    // history.push(`${CASUALITY_GENERAL.urls.resumen}?id=${catalogo?.idCotizacion || ""}`);
    history.push(
      `${CASUALITY_GENERAL.urls.facturacion}?idPoliza=${id}&ramo=${
        CASUALITY_GENERAL.codProducto
      }&idCot=${catalogo?.idCotizacion || ''}`
    );
  };

  useEffect(() => {
    if (id) {
      getData();
    } else {
      history.push(`/`);
    }
  }, [history, getData, id]);

  return (
    <Loading loading={loading}>
      {catalogo?.DatosContratanteAsegurado && <ModalContratante catalogo={catalogo} />}
      <div className="cr-content">
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS.breadCrumb} showPaths={false} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY_GENERAL].breadCrumbPasosCotizacion[4]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY_GENERAL]?.pasosCotizacion}
          />

          {/* <DevTool control={methods.control}/> */}
          <FormProvider {...methods}>
            <form
              id="form-preguntas"
              onSubmit={methods.handleSubmit(onSubmit)}
              className="row d-flex flex-wrap justify-content-center"
            >
              <div className="col-10 d-flex justify-content-center">
                {validaciones && <DynamicForm {...validaciones} resources={catalogo} />}
              </div>
              <div className="col-12 d-flex flex-wrap justify-content-center">
                <div className=" col-12 row justify-content-center">
                  <div className="col-12 col-md-9 my-auto bg-white">
                    <h6 className="ml-2 py-2 text-center" style={{ fontSize: '20px' }}>
                      Recuerda que al dar click en guardar, tu información quedará almacenada y
                      podrás cerrar la ventana en cualquier momento para continuar después
                    </h6>
                  </div>
                </div>
                <div className="col-md-3 col-sm-12  mt-1">
                  <BaseButton
                    onClick={() => {
                      regresar();
                    }}
                    type="button"
                    textColor="white"
                    bgColor={COLORS.primary}
                  >
                    <i
                      className="pi pi-arrow-left"
                      style={{
                        position: 'relative',
                        top: '1px',
                        fontSize: '1.4rem',
                      }}
                    />{' '}
                    Atrás
                  </BaseButton>
                </div>
                <div className="col-md-3 col-sm-12  mt-1">
                  <BaseButton
                    type="button"
                    textColor="white"
                    bgColor={COLORS.primary}
                    onClick={() => {
                      guardarInformacion(methods.getValues(), true);
                    }}
                  >
                    <i
                      className="pi pi-save"
                      style={{
                        position: 'relative',
                        top: '2px',
                        fontSize: '1.4rem',
                      }}
                    />{' '}
                    GUARDAR
                  </BaseButton>
                </div>
                <div className="col-md-3 col-sm-12  mt-1">
                  <BaseButton
                    textColor="white"
                    type="submit"
                    bgColor={COLORS.primary}
                    //onClick={onClickContinuar}
                  >
                    Continuar{' '}
                    <i
                      className="pi pi-arrow-right"
                      style={{
                        position: 'relative',
                        top: '1px',
                        fontSize: '1.4rem',
                      }}
                    />
                  </BaseButton>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
export default withValidarRecuperar(ContratanteCasualityGenerales);
